export default __webpack_public_path__ + "static/media/business-wallet-bg.d1f92a43.png";